import { post } from '../../../util/api'
import * as selector from './selector'
import * as type from './type'


export const changeEmployee = (name, value) => ({
    type: type.CHANGE_EMPLOYEE,
    payload: {
        name,
        value,
    },
})

export const setSipGateDeviceIdRequest = () => ({
    type: type.SET_SIPGATE_DEVICE_ID_REQUEST,
})

export const setSipGateDeviceIdSuccess = (sipGateDeviceId) => ({
    type: type.SET_SIPGATE_DEVICE_ID_SUCCESS,
})

export const setSipGateDeviceIdError = (error) => ({
    type: type.SET_SIPGATE_DEVICE_ID_ERROR,
    payload: {
        error,
    },
})

export const setSipGateDeviceId = () => (dispatch, getState) => {
    const state = getState()
    const sipGateDeviceId = selector.selectSipGateDeviceId(state)
    dispatch(setSipGateDeviceIdRequest())

    post('/api/employeee/set-sipgate-device-id', {
        sipGateDeviceId,
    })
        .then(empty => {
            dispatch(setSipGateDeviceIdSuccess())
        })
        .catch(error => {
            dispatch(setSipGateDeviceIdError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/employee/state/action.js